import { pb } from './pb';

export async function fetchReferencesPublic(){
  const res = await pb.collection('references').getList(1, 100, {
    filter: 'published = true',
    sort: 'order,name',
  });
  return res.items;
}

export async function fetchReferencesAdmin(page = 1, perPage = 50){
  return pb.collection('references').getList(page, perPage, {
    sort: 'order,name',
  });
}

export async function createReference(data){
  return pb.collection('references').create(data);
}

export async function updateReference(id, data){
  return pb.collection('references').update(id, data);
}

export async function deleteReference(id){
  return pb.collection('references').delete(id);
}
